import Axios from 'axios';
import header from './auth/header';

const API_URL_V3 =  process.env.API_URL + '/api/v3/';

class MarketingAgency {
    statistic() {
        return Axios.get(API_URL_V3 + 'agents/get-statistics?with=agenProfile,agenProfile.legalEntityType,agenProfile.createdBy', { headers: header() });
    }
    listPengajuan() {
        return Axios.get(API_URL_V3 + 'pengajuan/agents?with=agenProfile,agenProfile.legalEntityType,agenProfile.createdBy', { headers: header() });
    }
    index() {
        return Axios.get(API_URL + 'mitra-list', { headers: header() });
    }

    show(mitra) {
        return Axios.get(API_URL + `mitra/${mitra}`, { headers: header() });
    }

    payments(mitra) {
        return Axios.get(API_URL_V3 + `pengajuan/agent-service-fees/agents`, { headers: header() });
    }

    confirmationPayment(id, data) {
        return Axios.post(API_URL_V3 + `pengajuan/agent-service-fees/agents/transaction-id/${id}/proof/approval`, data, { headers: header() });
    }

    generateLink(){
        return Axios.get(API_URL_V3 + 'agents/generate-link', { headers: header() });
    }
}

export default new MarketingAgency();



// WEBPACK FOOTER //
// ./src/api/marketingAgency.js